import * as React from "react";
import "./style.scss";
import { INavbar } from "./Navbar";
import LoginForm from "@Components/LoginForm";
import { ContainerForgotPassWord, StyledLink } from "@Styled/Pages/Login";
import { useTranslation } from "react-i18next";

const Navbar: React.FunctionComponent<INavbar.IProps> = (): JSX.Element => {
    const { t } = useTranslation();
    return (
        <nav className="Menu">
            <LoginForm />
            <ContainerForgotPassWord>
                <StyledLink className="Forgot-password" to="/forgot-password">
                    {t("login.forgot_password")}
                </StyledLink>
                <span className="forgot"> &nbsp;{t("login.no_problem")}</span>
            </ContainerForgotPassWord>
        </nav>
    );
};

export { Navbar };
